module.exports = __webpack_public_path__ + "static/media/process-diagram.d6718376.svg";